module.exports = __webpack_public_path__ + "img/20211029-local-startup-experience-sharing.1f3c8bce.jpg";